import { render, staticRenderFns } from "./systemSettingsOrder.vue?vue&type=template&id=6bf5fe94&scoped=true&"
import script from "./systemSettingsOrder.vue?vue&type=script&lang=js&"
export * from "./systemSettingsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf5fe94",
  null
  
)

export default component.exports